export interface OperationErrorData {
  error_title: string;
}

export class OperationError extends Error {
  constructor(
    public operationId: string,
    public data: unknown | null | OperationErrorData,
    public errorCode: number,
  ) {
    super(`Operation with id ${operationId} failed due to ${errorCode} error code`);
  }
}
